

export class PortfolioFilter {

	// Properties
	Name = '';
	Desc = '';
	Category = '';
	Year = '';
	Added: Date = undefined;
	FromDate: any = undefined;
	ToDate: any = undefined;
	AddBy = '';
}